module.exports = __webpack_public_path__ + "img/blocked.10700478.svg";